import {useMemo} from 'react';

import {ExperimentalInputs, ExperimentalInputsComponentName} from 'procedures/planning/ProcedurePlanTypes';
import {
  getVaryingParameterIndices,
  getVisibleConditionIndicesForMethod,
} from 'procedures/planning/useInputTable';
import {ExperimentMethod} from 'studies/typed/shared/procedure-runs/design-state/ExperimentalInputs';
import {BaseCondition} from 'studies/typed/shared/procedure-runs/design-state/useExperimentDesignState';

export function getNumFactorsSetForMethod(
  experimentalInputsByMethod: ExperimentalInputs,
  conditions: ReadonlyArray<BaseCondition>,
  methodId: string
): number {
  const experimentalInputs = experimentalInputsByMethod[methodId];
  if (experimentalInputs == null) {
    return 0;
  }
  const visibleConditionIndices = getVisibleConditionIndicesForMethod(conditions, methodId);
  return Object.values(ExperimentalInputsComponentName).reduce(
    (count, componentName) =>
      count + getVaryingParameterIndices(experimentalInputs, componentName, visibleConditionIndices).length,
    0
  );
}

export function useFactorsSetByMethodId({
  methods,
  experimentalInputs,
  conditions,
}: {
  methods: ReadonlyArray<ExperimentMethod>;
  experimentalInputs: ExperimentalInputs;
  conditions: ReadonlyArray<BaseCondition>;
}): Record<string, number> {
  return useMemo(() => {
    const factorsSetByMethodId: Record<string, number> = {};
    methods.forEach((method) => {
      factorsSetByMethodId[method.id] = getNumFactorsSetForMethod(experimentalInputs, conditions, method.id);
    });
    return factorsSetByMethodId;
  }, [conditions, experimentalInputs, methods]);
}
